import { List,Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { SizeRecord } from "../../helper/SizeRecord";
import { MindmapViewOptionsRecord } from "./MindmapViewOptionsRecord";
import { OutlineViewOptionsRecord } from "./OutlineViewOptionsRecord";
import { RelationshipViewOptionsRecord } from "./RelationshipViewOptionsRecord";
import { SpreadsheetViewOptionsRecord } from "./SpreadsheetViewOptionsRecord";
import { SubwayViewOptionsRecord } from "./SubwayViewOptionsRecord";
import { TimelineViewOptionsRecord } from "./TimelineViewOptionsRecord";

export const ViewRecord = Record({
  viewId: null,
  viewType: null,
  expandedItems: List(),
  timelineOptions: TimelineViewOptionsRecord(),
  relationshipOptions: RelationshipViewOptionsRecord(),
  mindmapOptions: MindmapViewOptionsRecord(),
  outlineOptions: OutlineViewOptionsRecord(),
  spreadsheetOptions: SpreadsheetViewOptionsRecord(),
  subwayOptions: SubwayViewOptionsRecord(),
  size: SizeRecord()
});

const data = {
  objects: {
    size: "SizeRecord",
    timelineOptions: "TimelineViewOptionsRecord",
    relationshipOptions: "RelationshipViewOptionsRecord",
    mindmapOptions: "MindmapViewOptionsRecord",
    outlineOptions: "OutlineViewOptionsRecord",
    spreadsheetOptions: "SpreadsheetViewOptionsRecord",
    subwayOptions: "SubwayViewOptionsRecord",
    expandedItems: "List"
  }
};
createFromJS.registerCallback("ViewRecord", createFromJS.createNestedCallback(ViewRecord, data));
